module.exports = __webpack_public_path__ + "img/20210731_144458.efde448c.jpg";